import { InjectionToken } from '@angular/core';

const ANGULAR_JS_SERVICE_NAMES = [
  'MessageStore',
  'UserProfileStore',
  'OrdersService',
  'JobStore',
  'BlockService',
  'RouterService',
  'ContentStore',
  'TranslateProviderService',
  'ShoppingCartStore',
  'JobCleanUpService',
  'VisualMerchandiseStore',
  'ContentChangeAction',
  'SelectionTemplateDataStore',
  'YearbookInfoService',
  'loggerService',
  '$rootScope',
  'SessionTimeoutAction',
  'LoginSuccessAction',
  'ProductCatalogStore',
  'SessionTimeoutService',
  'ConfirmSchoolService',
  'StorageService',
  'SubjectStore',
  'IdentityService',
  'SessionRecreatedAction',
  'SessionTimeoutAction',
  'ConfirmSchoolService',
  '$rootScope',
  '$http',
  '$q',
  '$timeout',
  'ErrorLogService',
  'StatsdService',
  'EventDataService',
  'LooksStore',
  'SubjectStore',
  'DashboardService',
  'ColorService',
  'OrderLineFactory',
  '$filter',
  'ItemService',
  'AnalyticsService',
  'StatesService',
  'CitiesService',
  'SchoolsService',
  'ValidationService',
  'ResourceConstants',
  'RewardStore',
  'GradeService',
  'SessionStorageService',
  'AnalyticsService',
  'SubjectStore',
  'AddressValidationService',
  'AddressConsistencyService',
  'EmailValidationService',
  'PaymentService',
  'OrderFormService',
  'MasterSubjectService',
  'FlightRecorderService',
  'ActiveJobChangedAction'
] as const;

export const angularjs = ANGULAR_JS_SERVICE_NAMES.reduce(
  (acc, serviceName) => ({
    ...acc,
    [serviceName]: new InjectionToken(serviceName)
  }),
  {} as { [K in (typeof ANGULAR_JS_SERVICE_NAMES)[number]]: InjectionToken<any> }
);

export const ANGULAR_JS_SERVICES = ANGULAR_JS_SERVICE_NAMES.map((serviceName) => ({
  provide: angularjs[serviceName],
  useFactory: (i: ng.auto.IInjectorService) => i.get(serviceName),
  deps: ['$injector']
}));
